import Vue from 'vue';

import Login from './Login.vue';
import injection from './lib/installer';
import store from './stores';
import login from './router/login';
import '../southcn-ui2/src/assets/less/global.less';
import '@/assets/less/global.less';

Vue.config.productionTip = false;
Vue.use(injection);
injection.store = store;

injection.api.setConfig({
    errorCallbacks: {
        '401': function redirectLogin () {
            // window.location.href = '/admin/logout';
            return Promise.reject({
                errcode: 40001,
                errmessage: '未登录'
            });
        }
    },
    fixedOptions: () => {
        const headers = {'Content-Type': 'application/json'};
        if (process.env.NODE_ENV === 'production') {
            headers['X-CSRF-TOKEN'] = window.laravel._CSRF;
        }
        return {
            method: 'post',
            headers
        };
    },
    extra: {}
});

/* eslint-disable no-new */
injection.Vue = new Vue({
    el: '#app',
    router: login,
    store: store,
    template: '<Login></Login>',
    components: {Login}
});

